import React from "react";
import { useNavigate } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

export default function WhatWeSource({ cards = [], eyebrow, heading }) {
  const navigate = useNavigate();
  const visible = cards.filter((c) => !c.hidden);
  if (!visible.length) return null;

  return (
    <section id="what-we-source" data-testid="what-we-source" className="bg-obsidian px-6 py-24 lg:px-10">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <Eyebrow>{eyebrow || "What We Source"}</Eyebrow>
          <h2 className="mt-5 max-w-2xl font-serif text-3xl leading-tight text-warmwhite lg:text-5xl">
            {heading || "Four disciplines. One discreet desk."}
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-px overflow-hidden border border-gold/15 bg-gold/15 md:grid-cols-2 lg:grid-cols-4">
          {visible.map((card, i) => {
            const Icon = Icons[card.icon] || Icons.Diamond;
            return (
              <Reveal key={card.key} delay={i * 0.08} className="h-full">
                <div className="group flex h-full flex-col bg-obsidian p-8 transition-colors duration-500 hover:bg-seablue/20"
                     data-testid={`source-card-${card.key}`}>
                  <Icon size={26} className="text-gold" strokeWidth={1.3} />
                  <h3 className="mt-6 font-serif text-2xl text-warmwhite">{card.title}</h3>
                  <p className="mt-4 flex-1 font-sans text-sm leading-relaxed text-softgrey">{card.body}</p>
                  <button onClick={() => navigate(card.link)}
                          className="mt-8 flex items-center gap-2 font-sans text-[12px] tracking-wide text-gold transition-all group-hover:gap-3">
                    {card.cta} <ArrowRight size={14} />
                  </button>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
